<template>
    <div class="agent-chat__message" :class="`agent-chat__message--${role}`">
        <div class="agent-chat__avatar" aria-hidden="true">{{ avatarLabel }}</div>
        <div class="agent-chat__bubble">
            <ChatResponse v-if="role === 'assistant'" :source="content" />
            <span v-else class="agent-chat__text">{{ content }}</span>
            <span
                v-if="streaming"
                class="agent-chat__typing"
                aria-label="Assistant is typing"
            >
                <span></span><span></span><span></span>
            </span>
            <div v-if="showApply" class="agent-chat__apply">
                <button type="button" class="btn btn-xs btn-default" @click="$emit('apply', content)">
                    {{ applyLabel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ChatResponse from './Response.vue';

export default {
    name: 'AgentChatMessage',
    components: { ChatResponse },
    emits: ['apply'],
    props: {
        role: {
            type: String,
            default: 'assistant',
        },
        content: {
            type: String,
            default: '',
        },
        streaming: {
            type: Boolean,
            default: false,
        },
        canApply: {
            type: Boolean,
            default: false,
        },
        applyLabel: {
            type: String,
            default: 'Use in reply',
        },
    },
    computed: {
        avatarLabel() {
            return this.role === 'user' ? 'Tu' : 'AI';
        },
        showApply() {
            return this.canApply && !this.streaming && this.role === 'assistant' && Boolean(this.content?.trim());
        },
    },
};
</script>

<style scoped>
.agent-chat__message {
    display: flex;
    gap: 8px;
    align-items: flex-start;
}

.agent-chat__message--user {
    flex-direction: row-reverse;
}

.agent-chat__avatar {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    background: #e2e8f0;
    color: #1e293b;
}

.agent-chat__message--assistant .agent-chat__avatar {
    background: #ea580c;
    color: #fff;
}

.agent-chat__bubble {
    max-width: 80%;
    padding: 8px 12px;
    border-radius: 12px;
    background: #f1f5f9;
    color: #0f172a;
    font-size: 14px;
    line-height: 1.5;
}

.agent-chat__message--user .agent-chat__bubble {
    background: #ea580c;
    color: #fff;
}

.agent-chat__text {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.agent-chat__apply {
    margin-top: 8px;
}

.agent-chat__typing {
    display: inline-flex;
    gap: 3px;
    margin-left: 4px;
    vertical-align: middle;
}

.agent-chat__typing span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.5;
    animation: agent-chat-typing 1s infinite;
}

.agent-chat__typing span:nth-child(2) {
    animation-delay: 0.15s;
}

.agent-chat__typing span:nth-child(3) {
    animation-delay: 0.3s;
}

@keyframes agent-chat-typing {
    0%, 60%, 100% {
        transform: translateY(0);
        opacity: 0.4;
    }
    30% {
        transform: translateY(-3px);
        opacity: 1;
    }
}
</style>
